import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CustomerSearchClient } from "../../../../../../Wrap/Api/Customer/CustomerSearch";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { EntityType } from "../../../../../../Wrap/Constants/Enums/EntityType";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";

export interface ICustomerSearchQuery {
    customerStatus: CustomerStatus;
    firstname: string;
    lastname: string;
    dateOfBirth: Date;
    clAccountId: string;
    customerRole: RoleType;
    visibleToAdviserId: number;
    entityType: EntityType;
    entityId: number;
}

export class CustomerSearchAction {
    public static searchCustomers(
        query: ICustomerSearchQuery,
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const client = new CustomerSearchClient();

        let firstname = query.firstname;
        let lastname = query.lastname;
        if (firstname && !firstname.includes("%")) {
            firstname += "%";
        }
        if (lastname && !lastname.includes("%")) {
            lastname += "%";
        }
        const promise = client.get(
            null,
            query.customerStatus,
            firstname,
            lastname,
            JsonDateParser.toJsonDate(query.dateOfBirth),
            null,
            query.clAccountId,
            query.customerRole,
            query.entityId,
            query.entityType,
            query.visibleToAdviserId,
            currentPage,
            count
        );
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {});
    }
}
